// extracted by mini-css-extract-plugin
export default {"customScrollbar":"Dialog_customScrollbar__gIoTt","dialogAnimation":"Dialog_dialogAnimation__zcaQ1","dialogFadeIn":"Dialog_dialogFadeIn__AA2JP"};